import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { RouterLink } from '@angular/router';
import { TeamMember } from '../../../app.models';
import { AppService } from '../../../app.service';
import { TeamMemberService } from '../team-teammembers.service';

@Component({
  selector: 'app-team-member-list',
  templateUrl: './team-member-list.component.html',
  styleUrls: ['./team-member-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [MatFormFieldModule, MatSelectModule, CommonModule, FormsModule, RouterLink, MatIconModule],
})
export class TeamMemberListComponent implements OnInit, OnDestroy {
  teamMembers: TeamMember[];
  isTeamMemberHovered = {};
  personalityTypeFilter: string = '';
  public personalityTypes: string[] = new Array<string>();

  constructor(
    private appService: AppService,
    private teamMemberService: TeamMemberService,
    private renderer: Renderer2,
  ) {
    this.renderer.addClass(document.body, 'teammembers-active');
  }

  ngOnInit() {
    this.teamMembers = this.appService.getTeamInfo().teamMembers.sort((a, b) => (a.lastName < b.lastName ? -1 : 1));
    var uniqueTypes = this.teamMembers
      .filter(function (tm) {
        return tm.status === 'Completed';
      })
      .map((member) => member.mbtiType)
      .filter(this.uniqueFilter);
    for (var i = 0; i < uniqueTypes.length; i++) {
      let count = this.teamMembers.filter(function (x) {
        return x.status === 'Completed' && x.mbtiType === uniqueTypes[i];
      }).length;
      this.personalityTypes.push(`${uniqueTypes[i]}` + ` (${count})`);
    }
  }

  teamMemberHover(teamMember: TeamMember) {
    this.teamMemberService.changeActiveType(teamMember.mbtiType);
  }

  teamMemberUnHover() {
    this.teamMemberService.changeActiveType('');
  }

  uniqueFilter(value, index, self) {
    return self.indexOf(value) === index;
  }

  applyFilter() {
    let selectedType = this.personalityTypeFilter;
    this.teamMembers = this.appService
      .getTeamInfo()
      .teamMembers.filter(function (member) {
        return member.status === 'Completed' && member.mbtiType === selectedType;
      })
      .sort((a, b) => (a.lastName < b.lastName ? -1 : 1));
    this.teamMemberService.changeActiveType(selectedType);
  }

  clearFilter() {
    this.personalityTypeFilter = '';
    this.teamMembers = this.appService.getTeamInfo().teamMembers.sort((a, b) => (a.lastName < b.lastName ? -1 : 1));
    this.teamMemberService.changeActiveType('');
  }
  ngOnDestroy(): void {
    this.renderer.removeClass(document.body, 'teammembers-active');
  }
}
